export { deviceQueries, deviceKeys } from './services/devices.queries';
export { devicesApi } from './services/devices.api';
export {
  useCreateDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
  useBulkDeleteDevicesMutation
} from './services/devices.mutations';
export { DeviceListing } from './components/device-listing';
export { DeviceFormDialog } from './components/device-form-dialog';
export { DeviceDiscoveryDialog } from './discovery';
export {
  dedupeScannerDevices,
  normalizeScannerName
} from './discovery/dwt-utils';
export {
  usePrinterDiscovery,
  type PrinterDiscoveryStatus,
  type DiscoveredPrinter,
  type UsePrinterDiscoveryResult,
  type UsePrinterDiscoveryOptions
} from './discovery/use-printer-discovery';
export type {
  Device,
  DeviceStatus,
  DeviceType,
  DevicesListParams,
  DeviceMetrics,
  CreateDeviceRequest,
  UpdateDeviceRequest,
  DiscoveredDevice
} from './types';
